function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTelegramMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0069ab",
      fillOpacity: 1
    },
    d: "M 15 0 C 6.714844 0 0 6.714844 0 15 C 0 23.285156 6.714844 30 15 30 C 23.285156 30 30 23.285156 30 15 C 30 6.714844 23.285156 0 15 0 Z M 15 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.296875 8.628906 L 19.621094 22.136719 C 19.621094 22.136719 19.246094 23.074219 18.214844 22.625 L 12.03125 17.882812 L 9.785156 16.796875 L 6 15.523438 C 6 15.523438 5.417969 15.316406 5.363281 14.867188 C 5.304688 14.417969 6.019531 14.175781 6.019531 14.175781 L 21.0625 8.273438 C 21.0625 8.273438 22.296875 7.730469 22.296875 8.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(82.352941%,89.803922%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 11.558594 21.984375 C 11.558594 21.984375 11.375 21.96875 11.152344 21.257812 C 10.925781 20.542969 9.785156 16.796875 9.785156 16.796875 L 18.871094 11.027344 C 18.871094 11.027344 19.394531 10.707031 19.375 11.027344 C 19.375 11.027344 19.46875 11.082031 19.1875 11.34375 C 18.90625 11.609375 12.050781 17.769531 12.050781 17.769531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.980392%,81.176471%,89.411765%)",
      fillOpacity: 1
    },
    d: "M 14.402344 19.699219 L 11.957031 21.929688 C 11.957031 21.929688 11.765625 22.074219 11.558594 21.984375 L 12.023438 17.84375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTelegramMenu);
export default __webpack_public_path__ + "static/media/mobileTelegramMenu.83c397457057117466b61d5dd52225e9.svg";
export { ForwardRef as ReactComponent };